import Scrollbar from 'react-perfect-scrollbar'
import { navigations } from '../../navigations'
import { EgretVerticalNav } from 'egret'

const Sidenav = ({ children }) => {
  return (
    <Scrollbar options={{ suppressScrollX: true }} className='scrollable position-relative'>
      {children}
      <EgretVerticalNav navigation={navigations} />
    </Scrollbar>
  )
}

export default Sidenav
